import * as dayjs from "dayjs";

import {
  buttons_text,
  alert_messages,
  response_error_messages,
  error_messages,
} from "../consts/messages";
import axios from "axios";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  checkActionCode,
  confirmPasswordReset,
  updatePassword,
} from "firebase/auth";
import { appConfig } from "../enviroments/enviroment";
import {
  user_firstName,
  user_lastName,
  user_username,
  user_age,
  user_gender,
  user_about,
  user_country,
  revert_user_image,
  user_is_showFaved,
} from "./edit";
import { fetchAppCheckToken, loadFirebaseAuth } from "./firebase";
import { validation_failed_border_color } from "../consts/colors";
import { rate, rated_by_me } from "./rating";
import {
  is_cooked_by_me,
  is_rated_by_me,
  is_done_by_me,
  setSlick,
} from "./cooked-by";
import { list_cookbooks_main } from "./cookbook";
import { authors_ids, set_can_favorite } from "./favorite";
import {
  handle_cookbook_box_after_login,
  render_my_cookbooks,
} from "../modules/cookbooksPageList";

export function catch_error(error) {
  console.log({ ...error });
}

function setCookie(cName, cValue, exp, path) {
  let date = new Date();
  date.setTime(date.getTime() + exp * 60 * 60 * 1000);
  const expires = `expires= ${date.toUTCString()}`;
  document.cookie = `${cName} = ${cValue}; ${expires};path=${path}`;
}

//update the user info if there's no image
export function update_user_without_image(
  firstName,
  lastName,
  username,
  age,
  gender,
  about,
  country,
  user_is_showFaved
) {
  const url = `${appConfig.API.URL}/updateUserInfo`;
  let body = {
    firstName: firstName,
    lastName: lastName,
    username: username,
    gender: gender,
    country: country,
    age: age,
    about: about,
    showFaved: user_is_showFaved,
  };
  axios
    .post(url, body, {
      headers: {
        "x-api-key": appConfig.API.KEY,
        Authorization: ` Bearer ${
          JSON.parse(localStorage.getItem("login_result"))?.access_token
        }`,
        contentType: "application/json; charset=utf-8",
      },
    })
    .then((res) => {
      revert_user_image();
      $("#edit_submit").removeClass("button--loading");
      localStorage.setItem("user_info", JSON.stringify(res.data.data));
    })

    .catch((err) => {
      $("#edit_submit").removeClass("button--loading");
      catch_error(err);
    });
}

//update the user info if there's an image
export function update_user_with_image(
  firstName,
  lastName,
  username,
  age,
  gender,
  about,
  country,
  image,
  user_is_showFaved
) {
  const url = `${appConfig.API.URL}/updateUserInfo`;
  let body = {
    firstName: firstName,
    lastName: lastName,
    username: username,
    gender: gender,
    country: country,
    age: age,
    about: about,
    photoURL: image,
    showFaved: user_is_showFaved,
  };
  axios
    .post(url, body, {
      headers: {
        "x-api-key": appConfig.API.KEY,
        Authorization: ` Bearer ${
          JSON.parse(localStorage.getItem("login_result"))?.access_token
        }`,
        contentType: "application/json; charset=utf-8",
      },
    })
    .then((res) => {
      revert_user_image();
      $("#edit_submit").removeClass("button--loading");
      localStorage.setItem("user_info", JSON.stringify(res.data.data));
      $("#loggedin-user-profile-image").attr("src", res.data.data.photoURL);
    })
    .catch((err) => {
      $("#edit_submit").removeClass("button--loading");
      catch_error(err);
    });
}

//upload user image and get url response
export function upload_user_image(image) {
  const url = `${appConfig.API.URL}/uploadPhoto`;
  let body = {
    image: image,
    fileName: Date.now().toString(),
  };
  axios
    .post(url, body, {
      headers: {
        "x-api-key": appConfig.API.KEY,
        contentType: "application/json; charset=utf-8",
        Authorization: ` Bearer ${
          JSON.parse(localStorage.getItem("login_result"))?.access_token
        }`,
      },
    })
    .then((res) => {
      update_user_with_image(
        user_firstName,
        user_lastName,
        user_username,
        user_age,
        user_gender,
        user_about,
        user_country,
        res.data.imageURL,
        user_is_showFaved
      );
    })
    .catch((err) => {
      catch_error(err);
      $("#edit_submit").removeClass("button--loading");
    });
}

export async function get_user_info(
  shouldAddImage = false,
  shouldRenderUserCookbooks = false,
  is_logged_in = true,
  shouldRedirect = false,
  redirectPage = "",
  isPublic = false,
  fingerprint = ""
) {
  if (localStorage.getItem("get_user_info")) return null;
  let appCheckToken = "";

  if (isPublic) {
    appCheckToken = await fetchAppCheckToken();
  }

  localStorage.setItem("get_user_info", true);

  let url = `${appConfig.API.URL}/getUserInfo`;
  if (isPublic) {
    url = `${appConfig.API.URL}/public/getUserInfo`;
  }

  let access_token = JSON.parse(
    localStorage.getItem("login_result")
  )?.access_token;

  let headers = {
    "x-api-key": appConfig.API.KEY,
    Authorization: ` Bearer ${access_token}`,
    "Cache-Control": "no-cache",
  };

  if (isPublic) {
    headers = {
      "Cache-Control": "no-cache",
      "browser-fingerprint": fingerprint,
      "x-appcheck-token": appCheckToken,
    };
  }

  axios
    .get(url, {
      headers: headers,
    })
    .then((res) => {
      localStorage.setItem("user_info", JSON.stringify(res.data.data));
      if ($("#not-logged-in-profile")) {
        $("#not-logged-in-profile").css("display", "none");
      }

      if (shouldAddImage) {
        var user_name = return_user_name();

        if ($("#loading-profile")) {
          $("#loading-profile").remove();
        }
        if (res.data.data.photoURL) {
          var element =
            $(`<li class="logged-in-profile" id="logged-in-profile"> <a data-gtm-event="profile_clicked" data-gtm-category="top_menu" data-gtm-label="${user_name}" href = "/profile" >
              <img src="${res.data.data.photoURL}" class="logged-in-profile">
              </a></li>`);
          $("#header-profile-props").append(element);
        } else {
          if (res.data.data.imageURL) {
            var element =
              $(`<li class="logged-in-profile" id="logged-in-profile"> <a data-gtm-event="profile_clicked" data-gtm-category="top_menu" data-gtm-label="${user_name}" href = "/profile" >
              <img src="${res.data.data.imageURL}" class="logged-in-profile">
              </a></li>`);
            $("#header-profile-props").append(element);
          } else {
            if (
              JSON.parse(localStorage.getItem("user")).providerData[0]
                .providerId == "facebook.com"
            ) {
              if (JSON.parse(localStorage.getItem("user"))?.photoURL !== "") {
                var element =
                  $(`<li class="logged-in-profile" id="logged-in-profile"><a data-gtm-event="profile_clicked" data-gtm-category="top_menu" data-gtm-label="${user_name}"  href = "/profile" >
                <img src="${
                  JSON.parse(localStorage.getItem("user"))?.photoURL
                }" class="logged-in-profile">
                </a></li>`);
                $("#header-profile-props").append(element);
              }
            } else {
              var element =
                $(`<li class="logged-in-profile" id="logged-in-profile"><a data-gtm-event="profile_clicked" data-gtm-category="top_menu" data-gtm-label="${user_name}"  href = "/profile" >
            <img src="/content/themes/atyabtabkha/src/assets/images/temp/profile-img.png" class="logged-in-profile">
            </a></li>`);
              $("#header-profile-props").append(element);
            }
          }
        }
      }
      if (shouldRenderUserCookbooks) {
        render_my_cookbooks();
      }
    })
    .then(() => {
      if (
        window.location.pathname.includes("/recipe/") &&
        !window.location.pathname.endsWith("recipe/")
      ) {
        is_favorited();
      }
    })
    .then(() => {
      if (
        window.location.pathname.includes("/recipe/") &&
        !window.location.pathname.endsWith("recipe/")
      ) {
        if (localStorage.getItem("user_info")) {
          if (JSON.parse(localStorage.getItem("user_info"))?.cookbooks) {
            $("#add_to_new_cookbook_box").removeClass("is-form-open");
            $("#add_to_cookbook_submit_container").css("display", "none");
          }
        }
        if (localStorage.getItem("render_cookbooks")) {
          localStorage.removeItem("render_cookbooks");
          append_to_dom(
            "popup-cookbook-open",
            "popup-book",
            list_cookbooks_main
          );
        }
        is_rated_by_me();
        rated_by_me();
      }
    })
    .then(() => {
      if (localStorage.getItem("cookbook_box_should_open")) {
        localStorage.removeItem("cookbook_box_should_open");
        if (!is_logged_in) {
          handle_cookbook_box_after_login();
        }
      }
    })
    .then(() => {
      login_success();
    })
    .then(() => {
      //^ _________________ Cookies Manipulation ________________

      // ~ Favorites

      if (localStorage.getItem("user_info")) {
        if (JSON.parse(localStorage.getItem("user_info"))) {
          if (JSON.parse(localStorage.getItem("user_info")).favorites) {
            if (
              Object.entries(
                JSON.parse(localStorage.getItem("user_info")).favorites
              ).length > 0
            ) {
              favorites = JSON.parse(
                localStorage.getItem("user_info")
              ).favorites;
              let favorites;
              favorites = JSON.parse(
                localStorage.getItem("user_info")
              ).favorites;
              setCookie("favorites", favorites, 1, "/profile/my-favorites");
            } else {
              setCookie("favorites", null, -1, "/profile/my-favorites");
            }
          }
        }
      }

      if (localStorage.getItem("get_user_info")) {
        localStorage.removeItem("get_user_info");
      }
    })
    .then(() => {
      if (shouldRedirect) {
        window.location.href = redirectPage;
      }
    })
    .catch((err) => {
      if (localStorage.getItem("get_user_info")) {
        localStorage.removeItem("get_user_info");
      }

      catch_error(err);
    });

  return true;
}

export function set_user_data() {
  if (!localStorage.getItem("user_info")) {
    return new Promise((resolve, reject) => {
      reject("Not logged in");
    });
  }

  return new Promise((resolve, reject) => {
    const url = `${appConfig.API.URL}/getUserInfo`;
    let access_token = JSON.parse(
      localStorage.getItem("login_result")
    )?.access_token;

    axios
      .get(url, {
        headers: {
          "x-api-key": appConfig.API.KEY,
          Authorization: ` Bearer ${access_token}`,
          "If-Modified-Since": new Date(
            dayjs(
              JSON.parse(localStorage.getItem("user_info")).lastUpdated
            ).format("ddd, DD MMM YYYY HH:mm:ss")
          ).toGMTString(),
        },
      })
      .then((res) => {
        localStorage.setItem("user_info", JSON.stringify(res.data.data));

        resolve("success");
      })
      .catch((err) => {
        if (err?.response?.status == 304) {
          reject("Up to Date");
        } else {
          reject(err);
        }
      });
  });
}

export function login_user(firebaseAuth, email, password) {
  signInWithEmailAndPassword(firebaseAuth, email, password)
    .then((res) => {
      localStorage.setItem("user", JSON.stringify(res.user));
      localStorage.setItem(
        "login_result",
        JSON.stringify({
          is_logged_in: true,
          access_token: res.user.accessToken,
          expiry_date: Date.now() + 50 * 60000,
        })
      );
    })
    .then(() => {
      get_user_info(true, false, true);
    })
    .catch((err) => {
      catch_error(err);

      if (
        err.message.includes(response_error_messages.email_not_found) ||
        err.message.includes(response_error_messages.invalid_password)
      ) {
        $("#login-error").text(error_messages.incorrect_email_or_password);
      }

      $("#login_submit").removeClass("button--loading");
    });
}

export function login_success() {
  $("#popup-login").remove();

  if (localStorage.getItem("favorite_item")) {
    handle_favorites(localStorage.getItem("favorite_item"));
    localStorage.removeItem("favorite_item");
  }

  if (localStorage.getItem("cookby_should_open")) {
    localStorage.removeItem("cookby_should_open");
    append_to_dom("popup-cooked-by-open", "popup-cock", is_cooked_by_me);
  }

  if (localStorage.getItem("popup_favorite_list_should_open")) {
    let postID = localStorage.getItem("popup_favorite_list_should_open_postID");
    let response_type = localStorage.getItem(
      "popup_favorite_list_should_open_response_type"
    );
    localStorage.removeItem("popup_favorite_list_should_open");
    localStorage.removeItem("popup_favorite_list_should_open_postID");
    localStorage.removeItem("popup_favorite_list_should_open_response_type");

    getPostData(postID, response_type)
      .then((res) => {
        append_to_dom(
          "popup-open-cooked-favorite-list",
          "popup-favorite-list",
          is_done_by_me,
          res
        );
      })
      .catch((er) => {
        console.log(er);
      });
  }

  if (localStorage.getItem("popup_cooked_list_should_open")) {
    let postID = localStorage.getItem("popup_cooked_list_should_open_postID");
    let response_type = localStorage.getItem(
      "popup_cooked_list_should_open_response_type"
    );
    localStorage.removeItem("popup_cooked_list_should_open");
    localStorage.removeItem("popup_cooked_list_should_open_postID");
    localStorage.removeItem("popup_cooked_list_should_open_response_type");

    function setSlickAndShowDetails() {
      is_done_by_me();
      setSlick();
    }

    getPostData(postID, response_type)
      .then((res) => {
        append_to_dom(
          "popup-open-cooked-favorite-list",
          "popup-cooked-list",
          setSlickAndShowDetails,
          res
        );
      })
      .catch((er) => {
        console.log(er);
      });
  }

  if (localStorage.getItem("open_submit_recipe")) {
    localStorage.removeItem("open_submit_recipe");
    append_to_dom("popup-recipe-open", "popup-recipe", null);
  }

  if (
    localStorage.getItem("pending_rating") &&
    localStorage.getItem("pending_rating_result")
  ) {
    let rating = JSON.parse(localStorage.getItem("pending_rating_result"));
    rate(rating.rate, rating.post_id);
    localStorage.removeItem("pending_rating_result");
    localStorage.removeItem("pending_rating");
  }
}

export function is_favorited() {
  let favorites = JSON.parse(localStorage.getItem("user_info"))?.favorites;

  let favorited = $("#onLikeClick").attr("data-id");
  for (let i in favorites) {
    if (favorites[i] == favorited) {
      $("#onLikeClick").attr("data-is-liked", true);
      $("#favorite-button-text").text(buttons_text.favorited);
      $("#favorite-button-text").css("color", "#F13467");
      $("#favorite-button-image").css(
        "filter",
        "invert(63%) sepia(76%) saturate(7491%) hue-rotate(324deg) brightness(95%) contrast(98%)"
      );
      $("#intercations-container").css("display", "block");
      $("#liked_counter").css("display", "block");
      $("#gallery-footer-inner").css("border-radius", "0 0 1rem 1rem");

      return null;
    }
  }
}

var action = "";
export function handle_favorites(post_id, is_fav_page) {
  let postID = "";
  let token = JSON.parse(localStorage.getItem("login_result"))?.access_token;
  const url = `${appConfig.API.URL}/favorite`;
  let headers = {
    "x-api-key": appConfig.API.KEY,
    Authorization: `Bearer ${token}`,
  };

  if (is_fav_page) {
    action = "delete";
  } else {
    if ($("#onLikeClick").attr("data-is-liked") == "true") {
      action = "delete";
    } else {
      action = "add";
    }
  }

  if (post_id) {
    postID = post_id;
  } else {
    postID = $("#onLikeClick").attr("data-id");
  }

  let body = {
    action: action,
    postID: postID,
    authorUIDs: authors_ids,
  };

  axios
    .post(url, body, { headers })
    .then((res) => {
      get_user_info(false, false, true);

      if (action == "add") {
        favorite_result();
      } else {
        unfavorite_result(is_fav_page, post_id);
      }

      if (is_fav_page) {
        $("#delete_fav_recipe_confirm").remove();
      }
    })
    .catch((err) => {
      catch_error(err);
      if (is_fav_page) {
        $("#delete_fav_recipe_confirm #recipe_delete_confirm").removeClass(
          "button--loading"
        );
      }
    });
}

function favorite_result() {
  set_can_favorite(true);
  $("#onLikeClick").attr("data-is-liked", true);
  $("#like-count").text(parseInt($("#like-count").text()) + 1);
  $("#favorite-button-text").text(buttons_text.favorited);
  $("#favorite-button-text").css("color", "#F13467");
  $("#favorite-button-image").css(
    "filter",
    "invert(63%) sepia(76%) saturate(7491%) hue-rotate(324deg) brightness(95%) contrast(98%)"
  );

  $("#favorite-tooltip-text").text(alert_messages.favorited);

  $("#favorite-tooltip").toggleClass("is-active");
  setTimeout(() => {
    $("#favorite-tooltip").toggleClass("is-active");
  }, 3000);
}

function unfavorite_result(is_fav_page, id) {
  set_can_favorite(true);

  if (is_fav_page) {
    $(".fav_span").text($(".fav_span").text() - 1);
    $(`#fav_post_${id}`).remove();
    $("#delete_fav_recipe_confirm #recipe_delete_confirm").removeClass(
      "button--loading"
    );
    $("#delete_fav_recipe_confirm").removeClass("is-active");
  } else {
    $("#onLikeClick").attr("data-is-liked", false);

    if (parseInt($("#like-count").text()) > 0) {
      $("#like-count").text(parseInt($("#like-count").text()) - 1);
    }

    $("#favorite-button-text").text(buttons_text.favorite);
    $("#favorite-button-text").css("color", "#2e2e2e");
    $("#favorite-tooltip-text").text(alert_messages.unfavorited);

    $("#favorite-tooltip").toggleClass("is-active");

    setTimeout(() => {
      $("#favorite-tooltip").toggleClass("is-active");
    }, 3000);
    $("#favorite-button-text").css("color", "#000");
    $("#favorite-button-image").css("filter", "none");
  }
}

export function is_register_validation_completed(
  register_email_validated,
  register_password_validated,
  register_confirm_password_validated
) {
  if (
    register_email_validated &&
    register_password_validated &&
    register_confirm_password_validated
  ) {
    $("#register-submit").prop("disabled", false);
  } else {
    $("#register-submit").prop("disabled", true);
  }
}

export function is_login_validation_completed(
  login_email_validated,
  login_password_validated
) {
  if (login_email_validated && login_password_validated) {
    $("#login_submit").prop("disabled", false);
  } else {
    $("#login_submit").prop("disabled", true);
  }
}

export function register_success() {
  setTimeout(() => {
    $("#register-success").remove();
  }, 5000);
}

export function register(firebaseAuth, email, register_password) {
  createUserWithEmailAndPassword(firebaseAuth, email, register_password)
    .then((res) => {
      $("#popup-register").remove();
      append_to_dom(
        "popup-register-success-open",
        "register-success",
        register_success
      );
    })
    .then(() => {
      if ($("#not-logged-in-profile")) {
        $("#not-logged-in-profile").css("display", "none");
      }

      var element =
        $(`<li class="loading-profile" id="loading-profile"><a href = "/profile" >
      <img src="/content/themes/atyabtabkha/src/assets/images/svg/ico-spinner-alt.svg">
      </a></li>`);

      $("#header-profile-props").append(element);
      setTimeout(() => {
        login_user(firebaseAuth, email, register_password);
      }, 5000);
    })
    .catch((err) => {
      catch_error(err);

      if (err.message.includes(response_error_messages.email_exists)) {
        $("#register-error").text(error_messages.email_exists);
      }

      $("#register-submit").removeClass("button--loading");
    });
}

export function register_send_email(firebaseAuth, email, password) {
  const url = `${appConfig.API.URL}/submitLead`;
  const body = {
    email: email,
    campaigns: {
      accountActivation: {
        activationURL: window.location.href + "?register=true",
      },
    },
  };

  axios
    .post(url, body, {
      headers: {
        Authorization: `Bearer ${appConfig.sendGridApiKey}`,
        "Content-Type": "application/json",
        "x-api-key": appConfig.API.KEY,
      },
    })
    .then((res) => {
      register(firebaseAuth, email, password);
    })
    .catch((err) => {
      catch_error(err);
    });
}

export function is_reset_validation_completed(reset_email_validated) {
  if (reset_email_validated) {
    $("#reset_submit").prop("disabled", false);
  } else {
    $("#reset_submit").prop("disabled", true);
  }
}

export function password_reset(code, password) {
  $("#update_reset_submit").addClass("button--loading");
  const firebaseAuth = loadFirebaseAuth();
  checkActionCode(firebaseAuth, code)
    .then(() => {
      confirmPasswordReset(firebaseAuth, code, password)
        .then(() => {
          password_reset_sucess();
        })
        .catch((err) => {
          catch_error(err);
          $("#update_reset_submit").removeClass("button--loading");
        });
    })
    .catch((err) => {
      if (err.code == "auth/invalid-action-code") {
        $("#reset-update-password-error").html(
          "انتهت صلاحية رابط إعادة تعيين كلمة المرور، أرسلي الطلب من جديد <a>من هنا</a>"
        );
      }

      catch_error(err);
      $("#update_reset_submit").removeClass("button--loading");
    });
}

export function password_reset_sucess() {
  $("#update_reset_password").remove();
  append_to_dom(
    "popup-reset-password-success-open",
    "reset-password-success",
    null
  );

  setTimeout(() => {
    $("#reset-password-success").remove();
  }, 5000);
}

export function is_password_validated(password, verified_password, id) {
  if (password && verified_password) {
    $(`#${id}`).prop("disabled", false);
  } else {
    $(`#${id}`).prop("disabled", true);
  }
}

export function send_reset_link(email) {
  document.getElementById("reset_submit").classList.add("button--loading");
  let URLLink = window.location.href;
  if (URLLink[URLLink["length"] - 1] == "#") {
    URLLink = URLLink.replace("#", "");
  }
  const url = `${appConfig.API.URL}/resetPassword`;
  let body = {
    passwordResetLink: URLLink,
    email: email,
  };

  let headers = {
    Authorization: `Bearer ${appConfig.sendGridApiKey}`,
    "x-api-key": appConfig.API.KEY,
  };
  axios
    .post(url, body, { headers })
    .then((res) => {
      reset_link_success();
    })
    .catch((err) => {
      catch_error(err);

      $("#reset_submit").removeClass("button--loading");
      if (err?.response?.status === 500) {
        $("#reset-error").html(error_messages.email_not_found);
        $("#reset-email").css("borderColor", validation_failed_border_color);
      }
    });
}

export function reset_link_success() {
  append_to_dom("popup-forget-password-success-open", "reset-success", null);
  $("#forgot_password").remove();
  setTimeout(() => {
    $("#reset-success").remove();
  }, 5000);
}

export function update_password(password) {
  const firebaseAuth = loadFirebaseAuth();
  let user = firebaseAuth.currentUser;
  updatePassword(user, password)
    .then((res) => {
      update_password_success();
    })
    .catch((err) => {
      catch_error(err);

      $("#reset_submit").removeClass("button--loading");
      if (err.message.includes(response_error_messages.recent_login_needed)) {
        append_to_dom("popup-authenticate-open", "popup-authenticate", null);
      }
    });
}

export function update_password_success() {
  $("#update_password").remove();
  append_to_dom(
    "popup-edit-password-success-open",
    "password-edit-success",
    null
  );
  setTimeout(() => {
    $("#password-edit-success").remove();
  }, 5000);
}

export function promote_reset_password() {
  append_to_dom("popup-reset-password-open", "update_reset_password", null);
}

export function feature_not_ready() {
  $("#not-ready-tooltip").addClass("is-active");
  setTimeout(() => {
    $("#not-ready-tooltip").removeClass("is-active");
  }, 3000);
}

export function return_user_name() {
  var user_name = "";

  if (localStorage.getItem("user_info")) {
    if (JSON.parse(localStorage.getItem("user_info"))) {
      if (
        JSON.parse(localStorage.getItem("user_info")).firstName !== "" &&
        JSON.parse(localStorage.getItem("user_info")).lastName !== ""
      ) {
        user_name = `${
          JSON.parse(localStorage.getItem("user_info")).firstName
        } ${JSON.parse(localStorage.getItem("user_info")).lastName}`;
      } else {
        if (JSON.parse(localStorage.getItem("user_info")).username) {
          if (JSON.parse(localStorage.getItem("user_info")).username !== "") {
            user_name = JSON.parse(localStorage.getItem("user_info")).username;
          }
        } else {
          user_name = JSON.parse(localStorage.getItem("user_info")).email;
        }
      }
    }
  }
  return user_name;
}

export function append_to_dom(
  type,
  id,
  success_function = null,
  postdata = null
) {
  let url = "";
  if (window.location.hostname == "altis.altis.dev") {
    url = "/popups/";

    if (window.location.pathname.includes("/atyabtabkha")) {
      url = "/atyabtabkha/popups/";
    }
  } else {
    url = "/popups/";
  }
  let data = "";
  if (postdata) {
    data = `modal_type=${type}&data=${JSON.stringify(postdata)}`;
  } else {
    data = `modal_type=${type}`;
  }
  $.ajax({
    url: url,
    dataType: "html",
    type: "POST",
    data: data,

    success: function (html) {
      $("#page-wrapper").append(html);
      //_______________
      const $popups = $(".popup");
      $popups.removeClass("is-active");
      if ($(".popup-menu").hasClass("is-active")) {
        $(".popup-menu").removeClass("is-active");
        $("html").css("overflowY", "visible");
        $("#header-burger-menu").css("visibility", "visible").css("opacity", 1);
        $("#popup-menu-close").css("visibility", "hidden").css("opacity", 0);
      }
      if (id) {
        $(`#${id}`).addClass("is-active");
      }
      if (success_function) {
        success_function();
      }
      switch (type) {
        case ("popup-register-open", "popup-forget-password-open"):
          $("#popup-login").remove();
          $("#update_reset_password").remove();

          break;

        case "popup-login-open":
          $("#popup-register").remove();
          break;

        default:
          break;
      }
    },
    error: function (error) {
      console.log(error);
    },
  });
}

//call getExtendedData api endpoint

export const getPostData = (postID, type) => {
  return new Promise((resolve, reject) => {
    let token = JSON.parse(localStorage.getItem("login_result"))?.access_token;
    const url = `${appConfig.API.URL}/getExtendedPostData?postID=` + postID;
    let headers = {
      "x-api-key": appConfig.API.KEY,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    let result = "";

    axios
      .get(url, { headers })
      .then((res) => {
        let cookedUsers = [...new Set(res.data.cookedBy)];

        let cookedUserIDs = [];
        let cookedUsersInfo = [];
        let favoriteUserIDs = [];
        let favoriteUsersInfo = [];

        cookedUsers.forEach((userID) => {
          cookedUserIDs.push(userID);
        });

        cookedUserIDs.forEach((userID) => {
          cookedUsersInfo.push(res.data.usersInfo[userID]);
        });

        res.data.favoritedBy.forEach((userID) => {
          favoriteUserIDs.push(userID);
        });

        favoriteUserIDs.forEach((userID) => {
          favoriteUsersInfo.push(res.data.usersInfo[userID]);
        });

        result = {
          cookedUsersInfo,
          favoriteUsersInfo,
          type: type,
        };

        resolve(result);
      })
      .catch((er) => {
        reject(er);
        console.log(er);
      });
  });
};

export function toggle_sidebar(should_open) {
  if (should_open) {
    $("#header-burger-menu").css("visibility", "hidden").css("opacity", 0);
    $("#popup-menu-close").css("visibility", "visible").css("opacity", 1);
    $("html").addClass("html_no_scroll");

    $(".header-ad")
      .css("top", `${-$(".header-ad").outerHeight()}px`)
      .css("transition", "none");
  } else {
    $("#header-burger-menu").css("visibility", "visible").css("opacity", 1);
    $("#popup-menu-close").css("visibility", "hidden").css("opacity", 0);
    $("html").removeClass("html_no_scroll");
    $(".header-ad").css("top", "0");
    $("#popup-menu").remove();
  }
}

function returnYTEmbed(ID) {
  return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${ID}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
}

export function removeEmbeds() {
  $(".yt-container").each((i, item) => {
    $(item).html("");
  });

  if ($(".popup--story").hasClass("is-active")) {
    if (
      $(
        ".swiper-container-main>.swiper-wrapper>.swiper-slide-active>.swiper-container-child>.swiper-wrapper>.swiper-slide-active"
      ).find(".yt-container").length
    ) {
      let element = $(
        ".swiper-container-main>.swiper-wrapper>.swiper-slide-active>.swiper-container-child>.swiper-wrapper>.swiper-slide-active"
      )
        .find(".yt-container")
        .get(0);

      let template = returnYTEmbed($(element).siblings(".yt-id").val());

      $(element).html(template);
    }
  }
}
